import { SVGProps, Ref, forwardRef } from 'react';

export const UturnLeftOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8 1 1 8l7 7 1.273-1.273L4.446 8.9H15.05a6.15 6.15 0 1 1 0 12.3H3V23h12.05a7.95 7.95 0 1 0 0-15.9H4.445l4.828-4.827z"
                fill="currentColor"
            />
        </g>
    </svg>
));
UturnLeftOutlinedSize24Glyph.displayName = 'UturnLeftOutlinedSize24Glyph';
